import { StandardReport } from '../../../models';
import { SideNavCategory } from '../../../components/side-nav';

function compare(
  a: SideNavCategory<StandardReport>,
  b: SideNavCategory<StandardReport>,
): number {
  return a.name?.localeCompare(b.name);
}
export const buildAllReportCategory = (
  reportCategory: SideNavCategory<StandardReport>,
): SideNavCategory<StandardReport> => {
  const category: SideNavCategory<StandardReport> = {
    name: 'Searchable',
    key: 'Searchable',
    items: [],
  } as SideNavCategory<StandardReport>;

  const newReportCategory = { ...reportCategory };
  newReportCategory.items.forEach((item) => {
    item.items.forEach((x) => {
      const subCategory = category.items.find((y) => y.name === x.name);
      if (subCategory === undefined) {
        category.items.push({ ...x });
      } else {
        subCategory.items = subCategory.items.concat(x.items);
      }
    });
  });

  category.items.forEach((element) => {
    element.items.sort(compare);
  });

  category.items.sort(compare);
  return category;
};
